import { ReactComponent as Icon } from "../files/IMDB_Logo_2016.svg";
import ISVGIconProps from "../ISVGIconProps";

const ImdbIcon = ({ fill, style = {} }: ISVGIconProps) => {
    return <Icon fill={fill} style={style} />;
};

export default ImdbIcon;
